<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-05-26 18:59:47
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-19 17:12:47
 * @FilePath: \partner.chaoyongtuan.com\src\components\shopScore\view.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="mt-12 flex flex-align-center">
		<div :class="[item.class]" v-for="(item, index) in shoplist" :key="index">
			<template v-if="item.class === 'line'">
				<img src="@/assets/public/split-line.png" alt="" />
			</template>
			<template v-else>
				<p class="flex flex-align-center" style="line-height: 28px"
					><span class="font-bold">{{ shopScores[item.key] || '-' }}</span
					><span :class="['tag', getLevelClass(shopScores[item.level])]">{{ getLevelName(shopScores[item.level]) }}</span></p
				>
				<p class="mt-2 yx-color-info fz-12">{{ item.name }}</p>
			</template>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		shopScores: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			shoplist: [
				{
					key: 'shopScore',
					level: 'shopScoreLevel',
					name: '商家体验分',
					class: 'item',
				},
				{
					class: 'line',
				},
				{
					key: 'productScore',
					level: 'productScoreLevel',
					name: '商品体验',
					class: 'item ml-8',
				},
				{
					key: 'logisticsScore',
					level: 'logisticsScoreLevel',
					name: '物流体验',
					class: 'item ml-30',
				},
				{
					key: 'serviceScore',
					level: 'serviceScoreLevel',
					name: '商家服务',
					class: 'item ml-30',
				},
			],
		};
	},
	methods: {
		getLevelClass(val) {
			let classObj = {
				1: 'bgHeight',
				2: 'bgMiddle',
				3: 'bgBottom',
			};
			return classObj[val];
		},
		getLevelName(val) {
			let name = {
				1: '高',
				2: '中',
				3: '低',
			};
			return name[val];
		},
	},
};
</script>
<style lang="less" scoped>
.item {
	.tag {
		display: inline-block;
		padding: 0px 4px;
		border-radius: 50%;
		font-size: 20px;
		transform: scale(0.5);
	}
	.bgHeight {
		background-color: #ffeff3;
		color: #fe3665;
	}
	.bgMiddle {
		background-color: #fff6f2;
		color: #ff7038;
	}
	.bgBottom {
		background-color: #f0f1f5;
		color: #4e596a;
	}
}
.line {
	img {
		height: 44px;
	}
	margin: 0 16px;
}
</style>
